var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1883 14.4667V19.215C18.1883 19.635 18.1417 20.0317 18.0367 20.3933C17.605 22.1083 16.1817 23.1817 14.2217 23.1817H11.0483L7.52501 25.5267C7.00001 25.8883 6.30001 25.5033 6.30001 24.8733V23.1817C5.11001 23.1817 4.11834 22.785 3.43001 22.0967C2.73001 21.3967 2.33334 20.405 2.33334 19.215V14.4667C2.33334 12.25 3.71001 10.7217 5.83334 10.5233C5.98501 10.5117 6.13668 10.5 6.30001 10.5H14.2217C16.6017 10.5 18.1883 12.0867 18.1883 14.4667Z",
    fill: "#344c3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7083 18.2C22.19 18.2 23.4383 17.71 24.3017 16.835C25.1767 15.9717 25.6667 14.7233 25.6667 13.2417V7.29168C25.6667 4.55001 23.45 2.33334 20.7083 2.33334H10.7917C8.05001 2.33334 5.83334 4.55001 5.83334 7.29168V8.16668C5.83334 8.49334 6.09001 8.75001 6.41668 8.75001H14.2217C17.3833 8.75001 19.9383 11.305 19.9383 14.4667V17.6167C19.9383 17.9433 20.195 18.2 20.5217 18.2H20.7083V18.2Z",
    fill: "#344c3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.8627c54ffbf63bc2ae6d680b795f5bd7.svg";
export { ForwardRef as ReactComponent };